(ns frontend.view.settings2.zap-vaults.event
  (:require [common.util :as cu]
            [frontend.controller.websocket.event :as ws]
            [frontend.state.current-session :as session]
            [frontend.view.settings2.zap-vaults.model :as model]
            [potpuri.core :as potpuri]
            [re-frame.core :as rf]
            [ui.state.session.entity-utils :as entity-utils]))

(rf/reg-event-fx
  ::init
  (fn [{db :db} [_]]
    {:db (-> db
             (assoc-in model/active-tab-full-path :brand))}))

(rf/reg-event-fx
  ::set-active-tab
  (fn [{db :db} [_ tab]]
    {:db (-> db
             (potpuri/dissoc-in model/root-path)
             (assoc-in model/active-tab-full-path tab))}))


(rf/reg-event-fx
  ::set-button-color
  (fn [{db :db} [_ color]]
    {:db (assoc-in db model/button-color-full-path color)}))

(rf/reg-event-fx
  ::set-text-color
  (fn [{db :db} [_ color]]
    {:db (assoc-in db model/text-color-full-path color)}))

(rf/reg-event-fx
  ::set-back-url
  (fn [{db :db} [_ url]]
    {:db (assoc-in db model/back-url-full-path url)}))

(rf/reg-event-fx
  ::set-back-url-editable?
  (fn [{db :db} [_ v]]
    {:db (assoc-in db model/back-url-editable?-full-path (true? v))}))

(rf/reg-event-fx
  ::set-unauthorized-message
  (fn [{db :db} [_ v]]
    {:db (assoc-in db model/unauthorized-message-full-path v)}))

(rf/reg-event-fx
  ::set-unauthorized-message-editable?
  (fn [{db :db} [_ v]]
    {:db (assoc-in db model/unauthorized-message-editable?-full-path v)}))

(rf/reg-event-fx
  ::set-disclaimer-message
  (fn [{db :db} [_ v]]
    {:db (assoc-in db model/disclaimer-message-full-path v)}))

(rf/reg-event-fx
  ::set-disclaimer-confirm-text
  (fn [{db :db} [_ v]]
    {:db (assoc-in db model/disclaimer-confirm-text-full-path v)}))

(rf/reg-event-fx
  ::set-disclaimer-message-editable?
  (fn [{db :db} [_ v]]
    {:db (assoc-in db model/disclaimer-message-editable?-full-path v)}))

(rf/reg-event-fx
  ::set-members-editable?
  (fn [{db :db} [_ v]]
    {:db (assoc-in db model/members-editable?-full-path v)}))

(rf/reg-event-fx
  ::set-teams-editable?
  (fn [{db :db} [_ v]]
    {:db (assoc-in db model/teams-editable?-full-path v)}))

(rf/reg-event-fx
  ::upload-logo
  (fn [{db :db} [_ base64]]
    (when-not (cu/blank-value? base64)
      {:db       (assoc-in db model/uploading-logo-full-path true)
       ::ws/send {:id         :image-utils/upload-base64
                  :body       {:data base64}
                  :on-success [::upload-ok base64]
                  :on-error   [::upload-failed base64]}})))

(rf/reg-event-fx
  ::upload-ok
  (fn [{db :db} [_ _base64-image resp]]
    (let [url (:url (:body resp))]
      (js/console.log "Logo upload successful:" resp " > " url)
      {:db (-> db
               ;; Remove uploading state
               (potpuri/dissoc-in model/uploading-logo-full-path)
               ;; Store the CDN URL in optimistic updates
               (assoc-in model/logo-full-path url))
       })))

(rf/reg-event-fx
  ::upload-failed
  (fn [{db :db} [_ _base64-image error resp]]
    (js/console.error "Logo upload failed:" error resp)
    {:db (-> db
             ;; Remove uploading state
             (potpuri/dissoc-in model/uploading-logo-full-path)
             ;; Optionally store error state
             )
     ;; Show user-friendly error message
     ;; TODO: UI messages
     #_:fx #_[[:dispatch [:ui/show-notification
                          {:type    :error
                           :title   "Upload Failed"
                           :message "Failed to upload logo. Please try again."}]]]}))

(rf/reg-event-fx
  ::cancel
  (fn [{db :db} _]
    (let [active (get-in db model/active-tab-full-path)]
      {:db (-> db
               (potpuri/dissoc-in model/root-path)
               (assoc-in model/active-tab-full-path active))})))

(rf/reg-event-fx
  ::update-ok
  (fn [{db :db} [_ _resp]]
    {:db (-> db
             (potpuri/dissoc-in model/saving?-full-path))}))

(rf/reg-event-fx
  ::update-failed
  (fn [{db :db} [_ changes resp]]
    (js/console.warn "Failed to update entity " changes " >>> " resp)
    {:db (-> db
             (potpuri/dissoc-in model/saving?-full-path))}))

(rf/reg-event-fx
  ::save
  (fn [{db :db} [_ changes]]
    (let [default-config-id (->> @session/tenant
                                 :tenant/default-vault-config
                                 (entity-utils/eid))]
      {::ws/send {:id         :entity/update-attributes
                  :body       {:db/id default-config-id
                               :data  changes}
                  :on-success [::update-ok]
                  :on-error   [::update-failed changes]}
       :db       (-> db
                     (assoc-in model/saving?-full-path true))})))
